export default __webpack_public_path__ + "static/media/bank-visa-square.e9f9b20a.svg";